export default "__VITE_ASSET__DcD7drpL__"